import React, { useEffect, useState } from 'react'
import ReorderItems from './components/ReorderItems'

const ConfigOrderingModal = ({
  idModal,
  modal,
  setModal,
  config,
  handleOrder,
}) => {
  const [items, setItems] = useState([])

  const closeModal = () => {
    setModal(false)
    window.jQuery('#' + idModal).modal('hide')
  }

  const handleAccept = () => {
    if (config.level === 'all') {
      config.setDataMain(items)
      setModal(false)
      handleOrder({ items, level: config.level })
      window.jQuery('#' + idModal).modal('hide')
    }

    if (config.level === 'sub1') {
      //recorrer array principal y modificar index de sub1
      const newArray = config.dataMain.map((item, index) => {
        if (index === config.index)
          return { ...item, itemMain: { ...item.itemMain, items } }
        return item
      })
      config.setDataMain(newArray)
      setModal(false)
      handleOrder({ items: newArray, index: config.index, level: config.level })
      window.jQuery('#' + idModal).modal('hide')
    }
  }

  useEffect(() => {
    if (config.level === 'all') {
      setItems(config.dataMain)
    } else if (config.level === 'sub1') {
      setItems(config.dataMain[config.index].itemMain.items)
    }
  }, [config])

  return (
    <>
      {modal && (
        <div
          className="modal fade"
          data-backdrop="static"
          data-keyboard="false"
          id={idModal}
          tabIndex="-1"
          role="dialog"
          aria-labelledby={`${idModal}Title`}
          aria-hidden="true"
        >
          <div
            className={`modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md`}
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{config.title}</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {items && items.length > 0 && (
                  <ReorderItems
                    items={items}
                    setItems={setItems}
                    type={config.level}
                  />
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-migrates mr-3"
                  style={{ fontSize: 14 }}
                  onClick={closeModal}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-migrates "
                  onClick={handleAccept}
                >
                  Guardar ordenamiento
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ConfigOrderingModal
